var locales = {
  frc: 'fr-CA',
  dan: 'da',
  esp: 'es',
  fin: 'fi',
  rus: 'ru',
  chs: 'zh-Hans',
  hrv: 'hr',
  fra: 'fr',
  nld: 'nl',
  jpn: 'ja',
  cat: 'ca',
  hun: 'hu',
  ita: 'it',
  plk: 'pl',
  csy: 'cs',
  ptb: 'pt-BR',
  eng: 'en-GB',
  deu: 'de',
  rom: 'ro',
  cht: 'zh-Hant',
  kor: 'ko',
  trk: 'tr',
  ptg: 'pt-PT',
  enu: 'en',
  sve: 'sv',
  nor: 'no',
  zhh: 'zh-Hant-HK'
};
export var supportedLocales = [locales.enu, locales.deu, locales.fra, locales.eng, locales.esp, locales.ptb, locales.jpn, locales.chs, locales.zhh, locales.nld, locales.sve, locales.dan, locales.frc, locales.ita, locales.kor, locales.rus, locales.plk, locales.csy, locales.cht, locales.nor];
export var defaultLocale = locales.enu;
//# sourceMappingURL=consts.js.map